
import { i18nText } from '@/locales';
import {Form} from "@/form/form";
import {Validate} from "@/plugins/Vuelidate/Decorators";
import {numeric, required, requiredIf} from "vuelidate/lib/validators";
import {Component} from "vue-property-decorator";
import {FinanceOperationsAddFormRequestType} from "@/form/finance/finance_operations/FinanceOperationsAddForm.types";
import { fio, email } from "@/utils/validators";
import {IPaymentArticlesListItem} from "@/entity/finance/payment_articles/paymentArticles.types";
import {ICounterpartiesListItem} from "@/entity/finance/counterparties/counterparties.types";
import {IClientsListItem} from "@/entity/clients/clients.types";
import {IWorkersListItem} from "@/entity/workers/workers.types";
import {ICashboxListItem} from "@/entity/finance/cashbox/cashbox.types";

@Component
export default class FinanceOperationsAddForm extends Form{
    @Validate(required, i18nText("Введите дату"))
    date = '';
    @Validate(required, i18nText("Выберите тип"))
    paymentType: number | null = 0;
    targetType: number | null = 0;
    comment = null;
    types: Array<Record<string, any>> = [];
    @Validate(required, i18nText("Выберите получателя"))
    target: string | null = '';
    time: string | null = '00:00';
    cashbox = 0;
    user: number | null = null;
    @Validate(required, i18nText("Укажите сумму"))
    sum: number | null = null;
    visit: number | null = null;
    cashboxes: Array<Record<string, any>> = [];
    targets: Array<Record<string, any>> = [];
    salon_id: number | string | null = null;

    getFormData(): FinanceOperationsAddFormRequestType {
        return {
            date: this.date,
            paymentType: this.paymentType,
            targetType: this.targetType,
            comment: this.comment,
            target: this.target,
            sum: this.sum,
            cashbox: this.cashbox,
            visit: this.visit,
            user: this.user,
            time: this.time,
            salon_id: this.salon_id
        }
    }
    setFormData(types: IPaymentArticlesListItem[], 
                targets: IClientsListItem[] | ICounterpartiesListItem[] | IWorkersListItem[], 
                cashboxes: ICashboxListItem[],
                currentCashbox?: number,
                user?: number,
                salon_id?: number | string): void {
        this.types = [];
        this.cashboxes = [];
        this.targets = [];
        if(salon_id){
            this.salon_id = salon_id;
        }
        if(currentCashbox){
            this.cashbox = currentCashbox;
        }
        if(user){
            this.user = user;
        }
        for (let i = 0; i < types.length; i++) {
            if(!this.paymentType){
                this.paymentType = types[i].id;
            }
            this.types.push(types[i]);
        }
        for (let i = 0; i < targets.length; i++) {
            console.log('targets', this.targets)
            this.targets.push(targets[i]);
        }
        for (let i = 0; i < cashboxes.length; i++) {
            if(!this.cashbox && (currentCashbox == undefined || currentCashbox == null))
            {
                this.cashbox = cashboxes[i].id;
            }
            this.cashboxes.push(cashboxes[i]);
        }
    }
}
